<template >
  <div class="zcfg_list">
    <div class="zcfg_content" v-html="zcfgcontent"></div>
  </div>
</template>

<script>
  import {wechatZcfg} from "@/api";
  import {getQueryVariable} from "@/utils";

  export default {
    name: "zcfgneirong",
    data (){
      return {
        zcfgcontent:''
      }
    },
    mounted: function () {
      const companyCode = sessionStorage.getItem('companyCode') ? sessionStorage.getItem('companyCode') : getQueryVariable("state")
      wechatZcfg(companyCode, this.$route.params.ywmc).then(res => {
        this.zcfgList = res.data
        if (this.zcfgList.length) {
          this.zcfgcontent = this.zcfgList[0].content
        }
      })
    }
  }
</script>

<style scoped>
  .zcfg_list{
    min-height: 90%;
    background-color: #ffffff;
  }
  .zcfg_content{
    width: 90%;
    margin: 0 auto;
    padding-top: 20px;
    min-height: 80%;
    max-height: 80%;
  }
  .banner {
    text-align: center;
    position: relative;
  }

  .banner img {
    width: 100%;
    height: auto;
  }
  .info{
    position: absolute;
    top: 33%;
    left: 5%;
    color: #f1f1f1;
    text-align: left;
  }
  .info>.title_info{
    font-weight: bold;
    font-size: 24px;
    margin-bottom: 14px;
  }
  .info>.text_info{
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/view/xxcx/detailPage.vue